import { Grid, IconButton, Modal, Typography } from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";
import { withStyles } from "@material-ui/styles";
import styled, { css, keyframes } from "styled-components";

const blue = (props) => props.theme.palette.blue;
const opensans = (props) => props.theme.fonts.opensans;
const mulish = (props) => props.theme.fonts.mulish;

export const HeaderAccordion = styled.div`
  width: 100%;

  .MuiChip-root {
    cursor: pointer;
    padding: 20px;
    width: 100%;
    margin: 0;
    span {
      font-weight: bolder;
      font-family: ${mulish};
      font-size: 1.2rem;
    }
  }
`;

export const FilterOptionsTittle = styled.span`
  font-weight: bolder;
  font-size: 1.1rem;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  padding-right: 8px;
`;

export const ChartOptionsTittle = styled.span`
  display: block;
  font-weight: bolder;
  font-size: 1rem;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
`;

export const GridBreak = styled.div`
  width: 100%;
`;

export const CustomChartToolTip = styled.div`
  background-color: hsla(0, 0%, 100%, 1);
  margin: 0;
  padding: 6px;
  width: 240px;
  white-space: pre-line;
  font-family: ${opensans};
  p {
    margin: 5px;
    line-height: 18px;
  }
`;

export const TypographyStyled = styled(Typography)`
  font-weight: bold !important;
  font-size: 18px !important;
  color: ${blue};
  font-family: ${opensans} !important;
  text-transform: capitalize;
`;

export const ChartGridSubtitle = styled(Typography)`
  && {
    font-family: ${opensans};
  }
  color: #858585;
`;

export const GridCharts = styled(Grid)`
  margin-bottom: 10px !important;
`;

export const ChartContainer = styled.div`
  .recharts-label {
    text-anchor: middle;
    font-size: 0.9rem;
    fill: black;
    font-weight: bolder;
    font-family: Roboto, Helvetica, Arial, sans-serif;
  }

  .recharts-legend-item-text {
    font-size: 0.9rem;
    color: black !important;
    font-weight: bolder;
    font-family: Roboto, Helvetica, Arial, sans-serif;
  }

  .recharts-cartesian-axis-tick-value {
    font-family: Roboto, Helvetica, Arial, sans-serif;
    font-size: 0.8rem;
  }
`;

export const LoadingContainer = styled.div`
  background-color: #efefef;
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
`;

const rotateAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const RotatingIconButton = styled(({ isLoading, ...rest }) => (
  <IconButton {...rest} />
))`
  ${(props) =>
    props.isLoading &&
    css`
      animation: ${rotateAnimation} 0.5s infinite linear;
    `}
`;

export const PieChartTotalTitle = styled(Typography)`
  && {
    color: #858585;
    font-size: 12pt;
  }
`;

export const PieChartTotalValue = styled(({ color, ...props }) => (
  <Typography {...props} />
))`
  && {
    color: ${(props) => props.color};
    font-size: 16pt;
    font-weight: bolder;
  }
`;

export const ToggleButtonGroupContainer = styled.div`
  display: flex;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
`;

export const StyledToggleButtonGroup = withStyles((theme) => ({
  grouped: {
    margin: theme.spacing(0.5),
    border: "none",
    "&:not(:first-child)": {
      borderRadius: theme.shape.borderRadius,
    },
    "&:first-child": {
      borderRadius: theme.shape.borderRadius,
    },
  },
}))(ToggleButtonGroup);

export const StyledToggleButton = styled(ToggleButton)`
  && {
    &.Mui-selected {
      background-color: rgba(213, 228, 255, 0.5);
      color: ${({ theme }) => theme.palette.primary};
    }
    &.Mui-selected:hover {
      background-color: rgba(213, 228, 255, 1);
    }
  }
`;

export const StyledModal = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledModalCard = styled.div`
  background-color: #fff;
  border-radius: 4px;
  width: 60vw;
  margin: 0;
`;

export const StyledModalHeader = styled(Grid)`
  padding: 16px;
  border-bottom: 1px solid #dddddd;
  gap: 16px;
`;

export const StyledModalContent = styled(Grid)`
  padding: 16px;
  gap: 32px;
`;

export const StyledModalFooter = styled(Grid)`
  padding: 16px;
  border-top: 1px solid #dddddd;
  gap: 16px;
`;
